import { ofType } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { CommitmentService } from '../../../coaching-commitment/services/commitment.service';
import { QueueItem } from '../../../coaching-tags/models/queue.coaching.model';
import { catchErrorLogRet } from '../../../common/rest.operators';
import { PayloadAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { UserService } from '../../../user/user.service';
import { Draft, EvaluationService, Response } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../form.action';

import { Reload, reloadResult } from './reload.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const reload = (action: Observable<PayloadAction<ActionType, Reload>>) =>
    action.pipe(
        ofType(ActionType.EVAL_FORM__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);
            const userService =
                getModuleInjector().get<UserService>(UserService);
            const commitmentService =
                getModuleInjector().get<CommitmentService>(CommitmentService);

            const obses: [
                Observable<User>,
                Observable<Draft>,
                Observable<Response>,
                Observable<QueueItem[]>,
            ] = [
                userService.retrieve(act.payload.targetUserId),
                of(null),
                of(null),
                of(null),
            ];

            if (act.payload.draftId == null && act.payload.responseId == null) {
                obses[1] = service.lastDraft(
                    act.payload.templateVersionId,
                    act.payload.userId,
                    act.payload.targetUserId,
                    act.payload.timeZoneOffset,
                );
            }
            if (act.payload.draftId != null) {
                obses[1] = service.retrieveDraft(
                    act.payload.draftId,
                    act.payload.timeZoneOffset,
                );
            }
            if (act.payload.responseId != null) {
                obses[2] = service.retrieveResponse(
                    act.payload.responseId,
                    act.payload.timeZoneOffset,
                );
            }
            obses[3] = of(null).pipe(
                commitmentService.listAvailableQueues(() => ({
                    userId: act.payload.targetUserId,
                })),
                catchErrorLogRet([]),
            );

            return forkJoin(obses).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            targetUser: ret[0],
                            draft: ret[1],
                            response: ret[2],
                            queues: ret[3],
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );
